module.exports = __webpack_public_path__ + "mainassets/img/form_5h.b7371bde.svg";